import axios from 'axios'

import * as actions from "./index"

export function fetchStatus(option = "test") {
  return function (dispatch) {
    const fetches = [
      'celery-ping',
      'celery-registered',
      'celery-active',
      'celery-scheduled',
      'celery-reserved',
    ]
    dispatch({type: actions.FETCH_STATUS.PENDING});
    axios.all(fetches.map((fetchtype) => {
      return axios.get("/status/" + fetchtype + "/")
        .then((response) => {
          dispatch({type: actions.FETCH_STATUS.UPDATE, payload: {...response.data}})
        })
    }))
      .then(() => {
        // Both requests are now complete
        dispatch({type: actions.FETCH_STATUS.SUCCESS})
      })
      .catch((err) => {
        dispatch({type: actions.FETCH_STATUS.ERROR, payload: err})
      })
    // fetches.map((fetchtype) => {
    //     axios.get("/status/"+fetchtype+"/")
    //         .then((response) => {
    //             dispatch({type: actions.FETCH_STATUS.UPDATE, payload: {[fetchtype]: response.data}})
    //         })
    //         .catch((err) => {
    //             dispatch({type: actions.FETCH_STATUS.ERROR, payload: err})
    //         })
    // })

    // axios.get("/status/"+option+"/")
    //     .then((response) => {
    //         dispatch({type: actions.FETCH_STATUS.SUCCESS, payload: response.data})
    //         return axios.get("/status/"+option+"/")
    //     })
    //     .then((response) => {
    //         dispatch({type: actions.FETCH_STATUS.SUCCESS, payload: {'tes2':"test"}})
    //         return axios.get("/status/"+option+"/")
    //     })
    //     .then((response) => {
    //         dispatch({type: actions.FETCH_STATUS.SUCCESS, payload: response.data})
    //         return axios.get("/status/"+option+"/")
    //     })
    //     .then((response) => {
    //         dispatch({type: actions.FETCH_STATUS.SUCCESS, payload: response.data})
    //         return axios.get("/status/"+option+"/")
    //     })
    //     .catch((err) => {
    //         dispatch({type: actions.FETCH_STATUS.ERROR, payload: err})
    //     })
  }
}


// WEBPACK FOOTER //
// ./src/actions/statusActions.js